import React from 'react'
import Hero from '@/components/Hero'
import BreadGallery from '@/components/BreadGallery'
import Comparison from '@/components/Comparison'
import Benefits from '@/components/Benefits'
import Categories from '@/components/Categories'
import Authority from '@/components/Authority'
import MethodIntro from '@/components/MethodIntro'
import AppSection from '@/components/AppSection'
import ImmediateAccess from '@/components/ImmediateAccess'
import Testimonials from '@/components/Testimonials'
import Bonus from '@/components/Bonus'
import RecipesShowcase from '@/components/RecipesShowcase'
import WhyItWorks from '@/components/WhyItWorks'
import Offer from '@/components/Offer'
import Guarantee from '@/components/Guarantee'
import Faq from '@/components/Faq'
import FinalCta from '@/components/FinalCta'
import Footer from '@/components/Footer'

function App() {
  return (
    <div className="min-h-screen bg-[#FCFAF5]">
      <Hero />
      <BreadGallery />
      <Comparison />
      <Benefits />
      <Categories />
      <Authority />
      <MethodIntro />
      <AppSection />
      <ImmediateAccess />
      <Testimonials />
      <Bonus />
      <RecipesShowcase />
      <WhyItWorks />
      <Offer />
      <Guarantee />
      <Faq />
      <FinalCta />
      <Footer />
    </div>
  )
}

export default App
